
import AddAutoVehicle from './automotive/AddAutoVehicle.vue';
import AdditionalFees from './callouts/AdditionalFees.vue';
import AddToCartSidebar	from 'JS/components/side-menus/add-to-cart/AddToCartSidebar.vue';
import AutoSpecifications from './automotive/AutoSpecifications.vue';
import AutoStockInfo from './automotive/AutoStockInfo.vue';
import AuxItems from './AuxItems.vue';
import BatteryOptions from './automotive/BatteryOptions.vue';
import ChangeStoreSideMenu from 'JS/components/side-menus/change-store/ChangeStoreSideMenu.vue';
import CustomerVehicleSelectorSidebar from 'JS/automotive/shared/components/CustomerVehicleSelectorSidebar.vue';
import FitmentCta from './automotive/FitmentCTA.vue';
import globalData from 'JS/global/window-data';
import JoinRewardsCallout from 'JS/components/order/JoinRewardsCallout.vue';
import LazyCompareSimilarCarousel from './LazyCompareSimilarCarousel.vue';
import LazyProductCarousel from 'JS/components/carousels/LazyProductCarousel.vue';
import MiniNavBar from './MiniNavBar.vue';
import PaypalPayLaterMessage from 'Src/js/components/PaypalPayLaterMessage.vue';
import ProductFlag from "../../catalog/components/product-list/ProductFlag.vue";
import ProductImages from "./ProductImages.vue";
import ProductMastercardCallout from "./ProductMastercardCallout.vue";
import ProductOptions from './ProductOptions.vue';
import ProductPopularity from './ProductPopularity.vue';
import ProductPrice from "./ProductPrice.vue";
import ProductPromos from './ProductPromos.vue';
import ProductText from './ProductText.vue';
import ProductTitle from "./ProductTitle.vue";
import Prop65Warning from "./Prop65Warning.vue";
import SimilarProductsCarousel from './SimilarProductsCarousel.vue';
import SponsoredCarousel from 'JS/sponsored/components/SponsoredCarousel.vue';
import StoreDetailsModal from './StoreDetailsModal.vue';
import TireSpecifications from './automotive/TireSpecifications.vue';
import UpsellBundle from './bundles/UpsellBundle.vue';
import VehicleFitment from './automotive/VehicleFitment.vue';
import Vue from 'vue';
import { addBundleToCart, addProductComparisonToCart, addToCart } from '../services/AddToCartService';
import { AddToCartResult, IPDPAddToCartResponse } from 'JS/services/ProductService';
import { Component } from 'vue-property-decorator';
import { ILocalStoreJson } from 'JS/types/LocalStore';
import { IPdpProductCarousels, IProductDetailPageJson, IProductDetailProductJson, IProductPopularity, ITireAttributeValue, IUpsellBundle } from 'JS/types/PDP';
import { Watch } from 'vue-property-decorator';

@Component({
	name: "App",
	components: {
		AddAutoVehicle,
		SponsoredCarousel,
		MiniNavBar,
		ProductImages,
		ProductOptions,
		ProductPrice,
		ProductPromos,
		AdditionalFees,
		ProductText,
		ProductTitle,
		StoreDetailsModal,
		SimilarProductsCarousel,
		AutoStockInfo,
		TireSpecifications,
		AutoSpecifications,
		VehicleFitment,
		FitmentCta,
		CustomerVehicleSelectorSidebar,
		BatteryOptions,
		AuxItems,
		JoinRewardsCallout,
		ProductMastercardCallout,
		PaypalPayLaterMessage,
		Prop65Warning,
		LazyProductCarousel,
		ChangeStoreSideMenu,
		UpsellBundle,
		AddToCartSidebar,
		LazyCompareSimilarCarousel,
		ProductPopularity,
		ProductFlag,
	},
})
export default class ProductDetailsApp extends Vue {
	autoServiceInstall = false;
	showChangeStore = false;
	showAddToCartSidebar = false;
	userConfirmed: boolean = false;
	userAgreed: boolean = false;
	addToCartResponse: IPDPAddToCartResponse = null;
	bundleProducts: string[] = null;
	fromProductComparison = false;

	get carousels(): IPdpProductCarousels {
		return this.$store.state.carousels;
	}

	get details(): IProductDetailPageJson {
		return this.$store.state.details;
	}

	get localStore(): ILocalStoreJson {
		return this.$store.state.localStore;
	}

	get product(): IProductDetailProductJson {
		return this.$store.state.product;
	}

	get quantity(): number {
		return this.$store.state.quantity;
	}

	set quantity(val) {
		this.$store.commit('quantity', val);
	}

	get selectedAttributes() {
		return this.$store.state.selectedAttributes;
	}

	get shippingDeliveryDate() {
		return this.$store.state.shippingDeliveryDate;
	}

	get isPLA(): boolean {
		return this.$store.state.isPLA;
	}

	get showSpecialMessageBox(): boolean {
		return this.$store.getters.showSpecialMessageBox;
	}

	get isComingSoon(): boolean {
		return this.$store.getters.isComing;
	}

	get hasAdditionalCharge(): boolean {
		return this.$store.getters.hasAdditionalCharge;
	}

	get showListAddButton(): boolean {
		return this.isComingSoon || !this.showSpecialMessageBox;
	}

	get showStoreDetailsModal(): boolean {
		return this.$store.state.showStoreDetailsModal;
	}
	set showStoreDetailsModal(val) {
		this.$store.commit('showStoreDetailsModal', val);
	}

	get showInStoreLocation(): boolean {
		return !this.showSpecialMessageBox && this.localStore && !this.localStore.comingSoon;
	}

	get autoSpecTitle(): string {
		if (this.product.isAutomotiveBattery) {
			return "Battery Specifications";
		}
		return "Specifications";
	}

	get tireAttributes(): ITireAttributeValue[] {
		return this.product.tireAttributes?.dataAttributes ?? [];
	}

	get rewardsCallout() {
		const points: number = this.$store.getters.rewardsPoints;
		const showRewardsCallout = !this.product.price.isBelowMAP
			&& !this.product.isSoldOut
			&& !this.showSpecialMessageBox
			&& !!points;
		if (!showRewardsCallout) {
			return null;
		}

		return {
			points: points.toString(),
			customerHasRewards: !!globalData.customer?.isRewardsMember,
		};
	}

	get showMastercardCallout(): boolean {
		return this.$store.getters.showMastercardCallout;
	}

	get showAutoSpecs(): boolean {
		return Object.keys(this.product.autoSpecs).length > 0 || Object.keys(this.product.additionalAttributes).length > 0;
	}

	get showAddVehicle(): boolean {
		return (this.product.vehicleFitment?.isBattery && !this.product.vehicleFitment.autoPartsVehicle)
		|| (this.product.vehicleFitment?.isTire && !this.product.vehicleFitment.tireVehicle);
	}

	get productPriceAsNumber(): number {
		const price = this.product.price.price.replace(/[$,]+/g, "");
		return parseFloat(price);
	}

	get bundle(): IUpsellBundle {
		return this.$store.state.upsellBundle;
	}

	get productPopularity(): IProductPopularity {
		return this.$store.state.productPopularity;
	}

	get currentRewardsShippingOffer(): string {
		return this.$store.state.currentRewardsShippingOffer;
	}

	get addingToCart(): boolean {
		return this.$store.state.addingToCart;
	}

	get hasUpsellBundle(): boolean {
		return this.$store.getters.hasUpsellBundle;
	}

	get showCompareSimilar(): boolean {
		return this.$store.state.showCompareSimilar;
	}

	get flagText(): string {
		return this.$store.state.flagText;
	}

	get hasFlag(): boolean {
		return this.product.isNew || !!this.flagText;
	}

	showVehicleSelector: boolean = false;

	async refreshProduct() {
		await this.$store.dispatch('getProduct', this.product.blainNumber);
		this.showVehicleSelector = false;
	}

	//Provides initial install method for battery options.
	created() {
		if (this.product.isAutomotiveBattery) {
			const url = new URL(window.location.href);
			if (url.searchParams.has('delivery')) {
				this.autoServiceInstall = false;
			} else {
				this.autoServiceInstall = true;
			}
		}
	}

	async mounted() {
		const isTouchDevice = ("ontouchstart" in document.documentElement);
		this.$store.commit('isTouchDevice', isTouchDevice);
	}


	@Watch('product.blainNumber')
	onSelectedAttributesChanged(newNumber, oldNumber) {
		if (!!oldNumber && oldNumber != newNumber) {
			this.sendProductChangeEvent();
		}
	}

	sendProductChangeEvent() {
		window.blainGtmDataLayer.push({
			'blainNumber': this.product.blainNumber,
			'vendorBrand': this.product.brand,
			'productName': this.product.name,
			'totalValue': this.product.mapSafePrice,
			'belowMap': this.product.price?.isBelowMAP,
			'activeOnEcommerce': this.product.activeOnECommerce ? "Yes" : "No",
			'onlineStock': this.product.shipEcomOnHand,
			'activeInStorePickup': this.product.activeInStorePickup ? "Yes" : "No",
			'localStock': this.product.storeEcomOnHand,
			'productImage': this.product.primaryImageUrl,
			'event': "product_child_select"
		});
	}

	changeVehicle() {
		if (this.product.vehicleFitment.isTire) {
			this.showVehicleSelector = true;
		} else if (this.product.vehicleFitment.isBattery) {
			window.location.href = '/batteries/';
		} else {
			window.location.href = '/auto-parts';
		}
	}

	closeAddToCartSidebar() {
		this.bundleProducts = null;
		this.fromProductComparison = false;
		this.showAddToCartSidebar = false;
	}

	handleUserConfirm() {
		this.userConfirmed = true;
		if (this.fromProductComparison) {
			this.addProductComparisonToCart();
		} else if (this.bundleProducts) {
			this.addBundleToCart(this.bundleProducts);
		} else {
			this.tryAddToCart();
		}
	}

	onFulfillmentErrorConfirm(fulfillmentType) {
		this.$store.dispatch('setDeliveryType',
			{ fulfillmentType, allowDisabledOptions: false });
		this.handleUserConfirm();
	}

	onAgreementConfirm() {
		this.userAgreed = true;
		this.tryAddToCart();
	}

	async tryAddToCart() {
		if (this.addingToCart) {
			return;
		}
		// Show modal with spinner
		this.$store.commit('addingToCart', true);
		this.addToCartResponse = await addToCart(this.product, this.quantity, this.userConfirmed, this.userAgreed);
		this.showAddToCartSidebar = true;
		this.$store.commit('addingToCart', false);
	}

	async addBundleToCart(blainNumbers: string[]) {
		this.$store.commit('addingToCart', true);

		window.blainGtmDataLayer.push({
			'bundleSkus': blainNumbers,
			'event': "cart_bundle_add"
		});

		this.bundleProducts = blainNumbers;
		this.addToCartResponse = await addBundleToCart({
			primaryBlainNumber: this.product.blainNumber,
			blainNumbers: blainNumbers,
			userConfirmed: this.userConfirmed
		});
		this.showAddToCartSidebar = true;
		this.$store.commit('addingToCart', false);
	}

	async addProductComparisonToCart() {
		this.$store.commit('addingToCart', true);
		this.fromProductComparison = true;

		this.addToCartResponse = await addProductComparisonToCart({
			blainNumber: this.product.blainNumber,
			userConfirmed: this.userConfirmed
		});
		this.showAddToCartSidebar = true;
		this.$store.commit('addingToCart', false);
	}


	maxItemsHit() {
		this.addToCartResponse = { result: AddToCartResult.MaxLines };
	}
}
